import axios from "axios";

export const lookupGear = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/gear`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
